import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { useTranslation, Trans } from 'react-i18next';

const Line = (props) => {


    const { t, i18n } = useTranslation();

    const option = {
        color: ["rgba(45, 156, 219, 1)", 'rgba(249, 199, 79, 1)', "rgba(249, 65, 68, 1)"],
        title: {
            text: props?.title,
            textStyle: {
                color: "#fff"
            }
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: '#fff', // 设置背景颜色，使用 rgba 表示颜色和透明度
            textStyle: {
                color: '#000',
                fontSize: 14,
            },
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            textStyle: {
                color: "rgba(102, 102, 102, 1)",
            }
        },
        grid: {
            left: '1%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            name: "",
            boundaryGap: false,
            axisLine: {
                show: true, // 显示纵轴线
                onZero: false,
                lineStyle: {
                    color: "rgba(186,186,191, 0.53)"
                }
            },
            axisLabel: {
                color: "rgba(79, 79, 79, 1)"
            },
            splitLine: {
                show: true, // 显示纵轴的虚线
                lineStyle: {
                    type: 'dashed' // 设置虚线样式
                    , color: "rgba(186,186,191, 0.53)"
                }
            },
        },
        yAxis: [{
            type: 'value',
            axisLabel: {
                formatter: '{value} ',
                color: "rgba(79, 79, 79, 1)"
            },
            axisLine: {
                show: true, // 显示纵轴线
                lineStyle: {
                    color: "rgba(186,186,191, 0.53)"
                }
            },
            splitLine: {
                show: false, // 显示纵轴的虚线
                lineStyle: {
                    color: "rgba(186,186,191, 0.33)"
                }
            },
        }],
        series: [{
            name: t('carInfo.rented'),
            type: 'line',
            smooth: true,
            showSymbol: false,
            emphasis: {
                focus: 'series'
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: 'rgba(45, 156, 219, 1)' }, // 起始颜色（顶部）
                    { offset: 1, color: 'rgba(255, 255, 255, 0)' }  // 结束颜色（底部）
                ])
            },
            data: props?.data?.inventoryVehiclesCount,
        }, {
            name: t('carInfo.inventory'),
            type: 'line',
            smooth: true,
            showSymbol: false,
            emphasis: {
                focus: 'series'
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: 'rgba(249, 199, 79, 1)' }, // 起始颜色（顶部）
                    { offset: 1, color: 'rgba(147, 117, 47, 0)' }  // 结束颜色（底部）
                ])
            },
            data: props?.data?.rentedVehiclesCount,
        }, {
            name: t('carInfo.onLine'),
            type: 'line',
            smooth: true,
            showSymbol: false,
            emphasis: {
                focus: 'series'
            },
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: 'rgba(255, 0, 0, 0.8)' }, // 起始颜色（顶部）
                    { offset: 1, color: 'rgba(255, 255, 255, 0)' }  // 结束颜色（底部）
                ])
            },
            data: props?.data?.todayOnlineCount,
        }],
    };

    return (
        <ReactECharts option={option} />
    )

}

export { Line }